import { O2RebrandTheme } from './o2-rebrand-theme';

export default O2RebrandTheme;
